import React, { useEffect } from "react";
import Head from "next/head";
import PropTypes from "prop-types";

const GoogleAd = ({ slotId, adClass, loadAdsScript }) => {
  const googleAdId = "ca-pub-1050675995814642";

  useEffect(() => {
    try {
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({});
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }, []);

  return (
    <>
      {loadAdsScript && (
        <Head>
          <script
            async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1050675995814642"
            crossOrigin="anonymous"
            id="google-ads-script"
          />
          )
        </Head>
      )}
      <ins
        className={`adsbygoogle ${adClass || ""}`}
        style={{ display: "block" }}
        data-ad-client={googleAdId}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
        data-adtest={process.env.DEV_ONLY && "on"}
      />
    </>
  );
};

GoogleAd.propTypes = {
  slotId: PropTypes.string.isRequired,
  adClass: PropTypes.string,
  loadAdsScript: PropTypes.bool,
};

GoogleAd.defaultProps = {
  adClass: undefined,
  loadAdsScript: false,
};

export default GoogleAd;
